import { Tab } from '../../../types/Tab';
import type { SortOption } from '../../GenericComponents/HawkWidget/HawkWidgetAdvanced/model';

export const getSortOptions = (activeTab: Tab): SortOption[] => {
  if (activeTab.category === 'contracts') {
    return [
      {
        value: 'recommended',
        filterValue: '',
        label: 'reviewSortRecommended',
        desc: '',
      },
      {
        value: 'data_desc',
        filterValue: 'data',
        label: 'reviewSortDataDesc',
        desc: '1',
      },
      {
        value: 'data',
        filterValue: 'data',
        label: 'reviewSortDataAsc',
        desc: '0',
      },
      {
        value: 'monthly_cost_desc',
        filterValue: 'monthly_cost',
        label: 'reviewSortMonthlyCostDesc',
        desc: '1',
      },
      {
        value: 'monthly_cost',
        filterValue: 'monthly_cost',
        label: 'reviewSortMonthlyCostAsc',
        desc: '0',
      },
      {
        value: 'upfront_cost_desc',
        filterValue: 'upfront_cost',
        label: 'reviewSortPriceDesc',
        desc: '1',
      },
      {
        value: 'upfront_cost',
        filterValue: 'upfront_cost',
        label: 'reviewSortPriceAsc',
        desc: '0',
      },
    ];
  }
  return [
    {
      value: 'recommended',
      filterValue: '',
      label: 'reviewSortRecommended',
      desc: '',
    },
    {
      value: 'upfront_cost_desc',
      filterValue: 'upfront_cost',
      label: 'reviewSortUpfrontCostDesc',
      desc: '1',
    },
    {
      value: 'upfront_cost',
      filterValue: 'upfront_cost',
      label: 'reviewSortUpfrontCostAsc',
      desc: '0',
    },
  ];
};
